import React, { useState } from 'react'
import styles from './SendButton.module.css'
import useView from "../../../hooks/useView";
import config from "../../../config/enviroment"
import SendWhatsapp from '../sendWhatsapp.svg'
import { language } from '../../../utils/language';
import { useSelector } from 'react-redux';

export default function SendButton({ sendButton, phoneNumber }) {
  const homeState = useSelector(state => state.home);

  const [message, setMessage] = useState('')
  const { display } = useView();

  

  const handleSend = () => {
    if(message){
        if (!phoneNumber) {
            window.alert(language[homeState.default_language]["cellPhone"])
            return false
        }

        const encodedUrl = encodeURIComponent(window.location.href); 

        const linkMessage = encodedUrl +'%0A'+ message

        if(display === 'mobile'){
            window.open(`https://wa.me/${phoneNumber}?text=${linkMessage}`)
        }else{
            window.open(`https://web.whatsapp.com/send?phone=${phoneNumber}&text=${linkMessage}`)
        }


        setMessage('')
    }
  }

  const handleChange = (e) => {
    setMessage(e.target.value)
  }

  return (
    <div className={styles.root}>
        <input
            placeholder={language[homeState.default_language]["printMessage"]}
            className={styles.input}
            onChange={handleChange}
            value={message}
        />
        <button className={styles.button} onClick={handleSend}>
          <svg data-src={SendWhatsapp}/>
        </button>
    </div>
  )
}
